var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2042 7.79952L9.99993 2.5L7.79574 7.79952L2.07446 8.25819L6.43347 11.9922L5.10172 17.5752L9.99993 14.5833L14.8982 17.5752L13.5664 11.9922L17.9254 8.25819L12.2042 7.79952ZM11.3224 9.01304L9.99993 5.83333L8.67741 9.01304L5.24465 9.28825L7.86006 11.5286L7.06101 14.8784L9.99993 13.0833L12.9388 14.8784L12.1398 11.5286L14.7552 9.28825L11.3224 9.01304Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStar);
export default __webpack_public_path__ + "static/media/icn_star.927fb1a23405322731fe85b50edad347.svg";
export { ForwardRef as ReactComponent };